import { captureMessage, withScope } from '@sentry/react';

// CSP violations from these sources are not actionable application bugs: browser
// extensions, local/internal browser pages, and third-party tracking scripts.
const NON_ACTIONABLE_CSP_SOURCES = ['wasm-eval', 'chrome-extension', 'file:', 'about:', 'www.facebook.com', 'px.ads.linkedin.com', 'fonts.googleapis.com', 'fonts.gstatic.com'];

// TypeScript 7's DOM lib no longer declares these; browsers still implement them.

export const enableWebReporting = () => {
  if (typeof window.ReportingObserver === 'undefined') return;
  const reporting = new ReportingObserver(reports => reports.forEach(captureReport), {
    types: ['csp-violation'],
    buffered: true
  });
  reporting.observe();
};
const isNonActionableCspReport = report => {
  if (report.type !== 'csp-violation') return false;
  const blockedURL = report.body?.blockedURL ?? '';
  return NON_ACTIONABLE_CSP_SOURCES.some(source => blockedURL.includes(source));
};
const captureReport = report => {
  // Drop CSP violations from known non-actionable sources before reporting to Sentry.
  if (isNonActionableCspReport(report)) return;
  withScope(scope => {
    scope.setExtra('url', report.url);
    if (report.body) {
      const plainBody = report.body.toJSON();
      scope.setExtra('body', plainBody);
    }
    captureMessage(`[${report.type}]: ${getReportTitle(report)}`);
  });
};
const getReportTitle = report => {
  if (report.type === 'csp-violation') {
    const body = report.body;
    let host = body?.blockedURL ?? 'unknown host';
    const directive = body?.effectiveDirective ?? '';
    try {
      if (body?.blockedURL) host = new URL(body.blockedURL).host;
    } catch {}
    return `blocked request from ${host} ${directive}`.trim();
  }
  return 'unknown error';
};